import $ from "jquery";

export default function initMobileNav() {
  $(document).ready(function () {
    $('.js-toggle-category').on('click', function () {
      const $btn = $(this);
      const $parent = $btn.parent();
      const $nextSection = $parent.next();

      $btn.toggleClass('active');

      const expanded = $btn.attr('aria-expanded') === 'true';
      $btn.attr('aria-expanded', !expanded);

      $btn.find('.js-toggle-category-text').text(expanded ? 'Click to expand' : 'Click to collapse');

      $nextSection.stop(true, true).slideToggle(0);
    });
  });
}
